<div class="row">
  <div id="navBar" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <a routerLink="/">
      <div id="navbar-logoContainer">
        <div class="navbar-svg-container">
            <img src="assets/images/logo-airlines-blue.svg" width="100%" height="100%" class="navbar-svg-content" alt="">
        </div>
      </div>
    </a>
  </div>
</div>

<!-- login main container -->
<div id="login-container">
  <!-- login centered card -->
  <div id="login-card">

    <img src="assets/images/login.png" alt="Login">
    
    <p class="welcome">Bem Vindo ao Passe Livre</p>
    <p class="options_login">Selecione uma das opções a seguir para fazer login</p>

    <button class="btn-login btn-login_google" #loginGoogleBtn id="loginGoogleBtn" >
      <span><img class="icon-google" src="assets/images/google-icon.png" alt="icone Google"></span>
      Tripulantes LATAM
    </button>

    <button class="btn-login btn-external_login" (click)="toExternalLogin()">Tripulantes Externos</button>

    <p class="terms_text">
      Você está usando um aplicativo criado pela Latam Airlines. 
      <a class="terms_link" (click)="openPrivacyPolicy()">
        Veja aqui nossa Política de Privacidade
      </a>
    </p>
  </div>
</div>
